
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ritual-praxis-and-instructions/components/main_page",
      function () {
        return require("private-next-pages/ritual-praxis-and-instructions/components/main_page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ritual-praxis-and-instructions/components/main_page"])
      });
    }
  